<template>
	<div class="d-grid gap-2">
		<button
			@click="handleClick()"
			class="btn"
			:disabled="loading"
			:class="`btn-${color} ${classes}`"
			:type="button_type">
			<span v-if="props.loading">
				<i class="fa fa-spinner fa-spin"></i>
				<span v-if="props.loading_message">
					{{ props.loading_message }}
				</span>
				<span v-else> Carregando... </span>
			</span>
			<span v-else>
				<slot>Executar</slot>
			</span>
		</button>
	</div>
</template>

<script setup lang="ts">
	import { ButtonHTMLAttributes } from 'vue';

	const props = defineProps({
		loading: { type: Boolean, required: true },
		loading_message: { type: String, required: false },
		color: { type: String, required: false, default: 'primary' },
		action: { type: Function, required: false },
		type: { type: String, required: false, default: 'button' },
		classes: { type: String, required: false, default: '' },
	});

	const button_type = props.type as ButtonHTMLAttributes['type'];

	async function handleClick() {
		if (props.action) await props.action();
	}
</script>
